import BaseComponent from "../BaseComponent";
import styles from "./index.module.scss";
import BackgroundInput from "components/Properties/InputComponents/BackgroundInput";

const BackgroundComponent = ({active, backgroundColor, textureImage, inputOnChange, colorOnChange}) => {
  return (
    <BaseComponent title={"Background"} foldable={true}>
      <div className={styles.container}>
        <BackgroundInput active={active} name="DefaultTexture" inputOnChange={inputOnChange} thumbnail={textureImage} />
        <BackgroundInput active={active} name="BackgroundTexture" inputOnChange={inputOnChange} thumbnail={textureImage} />
        <BackgroundInput
          active={active}
          name="BackgroundColor"
          objectColor={backgroundColor ? "#" + backgroundColor.getHexString() : "#ffffff"}
          colorOnChange={colorOnChange}
        />
      </div>
    </BaseComponent>
  );
};

export default BackgroundComponent;
